import React from "react";
import { BrowserRouter } from "react-router-dom";
import { ConnectionProvider } from "./ConnectionContext";
import { SearchParamsProvider } from "./SearchParamsContext";

const Providers: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <BrowserRouter>
      <SearchParamsProvider>
        <ConnectionProvider>{children}</ConnectionProvider>
      </SearchParamsProvider>
    </BrowserRouter>
  );
};

export default Providers;
